



























import { TToastStatus, Toast } from '@/shared/models/Toast'
import { Component, Vue } from 'vue-property-decorator'
@Component({
  components: {
    // if this is not here, the thing won't work?? :^)))))))
  }
})

export default class ToastComponent extends Vue {
  private draggedItem: any;
  private toast: Toast = { title: '', description: '', status: 'info', id: 0 }
  private x = 0;
  private y = 0;
  private deltaY = 0;
  private deltaX = 0;
  private dragEvent = (e: MouseEvent) => this.onDrag(e)
  private dragEndEvent = (e: MouseEvent) => this.onDragEnd(e)
  private touchDragEvent = (e: TouchEvent) => this.onTouchDrag(e)
  private touchDragEndEvent = (e: TouchEvent) => this.onTouchDragEnd(e)

  public getIcon (status: TToastStatus) {
    switch (status) {
      case 'success':
        return require('@/assets/icons/info_circle/1 px/check.svg')
      case 'warning':
        return require('@/assets/icons/info_circle/1 px/exclamation_mark.svg')
      case 'error':
        return require('@/assets/icons/info_circle/1 px/cross.svg')
      case 'info':
        return require('@/assets/icons/info_circle/1 px/i_letter.svg')
      default:
        break
    }
  }

  public removeToast (toast: Toast) {
    const idx = this.$store.state.toasts.indexOf(toast)
    if (idx > -1) {
      this.$store.state.toasts.splice(idx, 1)
    }
  }

  public onDragStart (e: MouseEvent, toast: Toast) {
    this.draggedItem = e.currentTarget
    this.toast = toast
    this.x = e.clientX
    document.addEventListener('mouseup', this.dragEndEvent, { once: true })
    document.addEventListener('mousemove', this.dragEvent)
  }

  public onDrag (e: MouseEvent) {
    e.preventDefault()
    this.deltaX = e.clientX - this.x
    if (this.deltaX > 0) {
      this.draggedItem.style.setProperty('--x', this.deltaX + 'px')
    }
  }

  public onDragEnd (e: MouseEvent) {
    e.preventDefault()
    if (this.deltaX > 110) {
      this.removeToast(this.toast)
    } else {
      this.draggedItem.style.transition = '0.5s'
      this.draggedItem.style.setProperty('--x', 0)
    }
    document.removeEventListener('mousemove', this.dragEvent)
  }

  public onTouchDragStart (e: TouchEvent, toast: Toast) {
    e.preventDefault()
    this.toast = toast
    const element = e.target as HTMLElement
    if (element.classList?.contains('icon-right')) {
      this.removeToast(toast)
    }
    this.draggedItem = e.currentTarget
    this.y = e.touches[0].clientY

    document.addEventListener('touchend', this.touchDragEndEvent, { once: true })
    document.addEventListener('touchmove', this.touchDragEvent)
  }

  public onTouchDrag (e: TouchEvent) {
    e.preventDefault()
    this.deltaY = e.changedTouches[0].clientY - this.y
    if (this.deltaY < 0) {
      this.draggedItem.style.setProperty('--y', this.deltaY + 'px')
    }
  }

  public onTouchDragEnd (e: TouchEvent) {
    e.preventDefault()
    if (this.deltaY < -40) {
      this.removeToast(this.toast)
    } else {
      this.draggedItem.style.transition = '0.5s'
      this.draggedItem.style.setProperty('--y', 0)
    }

    document.removeEventListener('touchmove', this.touchDragEvent)
  }
}
